'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderTitle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HeaderTitleStyled = require('./styles/HeaderTitleStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
  size: _propTypes2.default.oneOf(['default', 'blank', 'dense'])
};

var defaultProps = {
  colorScheme: 'light',
  size: 'default'
};

function HeaderTitle(props) {
  return _react2.default.createElement(
    _HeaderTitleStyled.HeaderTitleStyled,
    { colorScheme: props.colorScheme, size: props.size },
    props.children
  );
}

HeaderTitle.propTypes = propTypes;
HeaderTitle.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-header/dist/HeaderTitle/HeaderTitle.js
// module id = 699
// module chunks = 0